import TableChartWidget from './table-chart.widget';
export default TableChartWidget;
